import request from '@/utils/request'
import api from '../api'

export class Fee {
  feeSearch(data) {
    return request({
      url: api.fee.feeSearch,
      method: 'post',
      data
    })
  }
  feeDownload(data) {
    return request({
      url: api.fee.feeDownload,
      method: 'post',
      data
    })
  }
  feeConfirm(params) {
    return request({
      url: api.fee.feeConfirm,
      method: 'put',
      params
    })
  }
  detailSearch(data) {
    return request({
      url: api.fee.detailSearch,
      method: 'post',
      data
    })
  }
  detailRetrieve(params) {
    return request({
      url: api.fee.detailRetrieve,
      method: 'get',
      params
    })
  }
  detailDownload(data) {
    return request({
      url: api.fee.detailDownload,
      method: 'post',
      data
    })
  }
}